// components/ui/index.jsx
import { T } from "../Tokens";

export const GlobalStyles = () => (
  <style>{`
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    html, body, #root { height: 100%; }

    ::-webkit-scrollbar { width: 3px; height: 3px; }
    ::-webkit-scrollbar-track { background: transparent; }
    ::-webkit-scrollbar-thumb { background: ${T.bg4}; border-radius: 2px; }

    @keyframes fadeUp {
      from { opacity: 0; transform: translateY(6px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    @keyframes blink {
      0%, 80%, 100% { opacity: 0.15; }
      40% { opacity: 1; }
    }
    @keyframes shimmer {
      0%   { background-position: -200% center; }
      100% { background-position:  200% center; }
    }

    .nav-btn {
      padding: 0 18px; height: 44px;
      background: none; border: none;
      border-bottom: 2px solid transparent;
      color: ${T.textDim}; font-size: 11px; cursor: pointer;
      display: flex; align-items: center; gap: 7px;
      font-family: ${T.fontMono}; letter-spacing: 0.03em;
      transition: color 0.15s, border-color 0.15s;
      white-space: nowrap;
    }
    .nav-btn:hover { color: ${T.textSecondary}; }
    .nav-btn.active { color: ${T.greenText}; border-bottom-color: ${T.green}; }

    .suggestion-btn {
      padding: 6px 12px; border-radius: ${T.radiusSm};
      background: ${T.bg2}; border: 1px solid ${T.border};
      font-size: 11px; color: ${T.textSecondary}; cursor: pointer;
      font-family: ${T.fontMono}; transition: all 0.15s; text-align: left;
    }
    .suggestion-btn:hover {
      border-color: ${T.amberBorder}; color: ${T.amberText}; background: ${T.amberDim};
    }

    .session-card {
      background: ${T.bg2}; border: 1px solid ${T.border};
      border-radius: ${T.radiusLg}; padding: 14px 16px;
      cursor: pointer; position: relative;
      transition: border-color 0.15s, background 0.15s;
    }
    .session-card::before {
      content: ''; position: absolute; left: 0; top: 0; bottom: 0;
      width: 3px; background: ${T.border};
      transition: background 0.15s;
      border-radius: 10px 0 0 10px;
    }
    .session-card:hover { border-color: ${T.borderHover}; background: ${T.bg3}; }
    .session-card:hover::before { background: ${T.green}; }

    .send-btn {
      width: 38px; height: 38px; border-radius: ${T.radius};
      background: ${T.greenDim}; border: 1px solid ${T.greenBorder};
      cursor: pointer; display: flex; align-items: center; justify-content: center;
      flex-shrink: 0; transition: all 0.15s;
    }
    .send-btn:hover:not(:disabled) { background: #2a4010; border-color: ${T.green}; }
    .send-btn:disabled { opacity: 0.3; cursor: not-allowed; background: ${T.bg3}; border-color: ${T.border}; }

    .input-wrap {
      flex: 1; background: ${T.bg2}; border: 1px solid ${T.border};
      border-radius: ${T.radius}; padding: 9px 13px;
      display: flex; align-items: center; gap: 8px;
      transition: border-color 0.15s, box-shadow 0.15s;
    }
    .input-wrap:focus-within { border-color: ${T.green}; box-shadow: 0 0 0 3px ${T.greenGlow}; }

    .sort-select {
      background: ${T.bg2}; border: 1px solid ${T.border};
      border-radius: ${T.radius}; color: ${T.textSecondary};
      font-size: 11px; padding: 8px 10px; font-family: ${T.fontMono};
      outline: none; cursor: pointer; appearance: none;
    }
    .sort-select:focus { border-color: ${T.borderHover}; }

    @media (max-width: 600px) {
  .hide-mobile { display: none !important; }
  .desktop-nav { display: none !important; }
  .desktop-only { display: none !important; }
  .mobile-menu-btn { display: flex !important; }
  .stats-grid { grid-template-columns: repeat(3, 1fr) !important; }
}
@media (min-width: 601px) {
  .mobile-menu-btn { display: none !important; }
  .mobile-dropdown { display: none !important; }
}
  /* Hide scrollbar on topic bar but keep scroll */
.topic-bar::-webkit-scrollbar { display: none; }
.mobile-dropdown-item {
  display: flex; align-items: center; gap: 12px;
  padding: 15px 20px; background: none; border: none;
  border-bottom: 1px solid ${T.border};
  font-size: 13px; cursor: pointer;
  font-family: ${T.fontMono}; text-align: left; width: 100%;
  transition: background 0.15s;
  color: ${T.textSecondary};
}
.mobile-dropdown-item:hover { background: ${T.bg2}; }
.mobile-dropdown-item.active { color: ${T.greenText}; background: ${T.greenDim}; }
.mobile-dropdown-item:last-child { border-bottom: none; }
  `}</style>
);

export const Chip = ({ children, variant = "default", style }) => {
  const variants = {
    default: { bg: T.bg3, border: T.border, color: T.textSecondary },
    green: { bg: T.greenDim, border: T.greenBorder, color: T.greenText },
    red: { bg: T.redDim, border: T.redBorder, color: T.redText },
    amber: { bg: T.amberDim, border: T.amberBorder, color: T.amberText },
    blue: { bg: T.blueDim, border: T.blueBorder, color: T.blueText },
  };
  const v = variants[variant] || variants.default;
  return (
    <span
      style={{
        fontSize: 9,
        fontWeight: 600,
        padding: "2px 7px",
        borderRadius: T.radiusSm,
        letterSpacing: "0.06em",
        background: v.bg,
        border: `1px solid ${v.border}`,
        color: v.color,
        textTransform: "uppercase",
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {children}
    </span>
  );
};

export const Dot = ({ active }) => (
  <div
    style={{
      width: 6,
      height: 6,
      borderRadius: "50%",
      flexShrink: 0,
      background: active ? T.green : T.amber,
      boxShadow: active ? `0 0 6px ${T.green}80` : "none",
      transition: "all 0.4s",
    }}
  />
);

export const Skeleton = ({ w = "100%", h = 12, style }) => (
  <div
    style={{
      width: w,
      height: h,
      background: `linear-gradient(90deg, ${T.bg3} 25%, ${T.bg4} 50%, ${T.bg3} 75%)`,
      backgroundSize: "200% 100%",
      animation: "shimmer 1.5s infinite",
      borderRadius: T.radiusSm,
      ...style,
    }}
  />
);

export const Divider = ({ label }) => (
  <div
    style={{ display: "flex", alignItems: "center", gap: 10, margin: "4px 0" }}
  >
    <div style={{ flex: 1, height: 1, background: T.bg4 }} />
    <span style={{ fontSize: 9, color: T.textDim, letterSpacing: "0.08em" }}>
      {label}
    </span>
    <div style={{ flex: 1, height: 1, background: T.bg4 }} />
  </div>
);
